<template>
  <div class="user-preview">
    <!-- USERで表示される画面のプレビュー表示 -->
    <div class="inner detail-top margin-0">
      <p class="mt10 fll hd-type-01 company-name">
        {{ offer.companyInfo.name }}
      </p>
      <ul class="date-set mt10 mb30 flr">
        <li class="fll">
          <p class="limit">
            掲載期間 yyyy/mm/dd〜yyyy/mm/dd
          </p>
        </li>
      </ul>
      <div class="clear" />
      <ul class="fs13 detail-menu clearfix">
        <li class="active">
          募集情報
        </li>
        <a><li>フォトクリップ</li></a>
        <a><li>インタビュー記事</li></a>
      </ul>

      <!-- JobPreviewHeader(求人名、新着、応募フォーム設定、雇用形態) -->
      <job-preview-header
        :title="offer.description.jobTitle"
        :is-simple="offer.description.isSimple"
        :is-original-entry-form="offer.description.isOriginalEntryForm"
        :employment-status="offer.description.employmentStatus"
        :comment-highlights="getCommentHighlights(targetIdMap.jobName)"
        :highlight-mode="highlightMode"
        :text-count-mode="offer.description.isShowMaxLength"
        v-on="$listeners"
      />

      <div class="contents-inner clearfix mb30">
        <!-- JobPreviewMainArticle(メイン記事キャッチコピー、メイン記事、メイン写真、メイン写真キャプション、アピールポイント) -->
        <job-preview-main-article
          :title="offer.description.mainTitle"
          :body="offer.description.mainBody"
          :photo-data="offer.description.mainPhoto"
          :caption="offer.description.mainCaption"
          :pr-codes="offer.description.prCodes"
          :comment-highlights="getAnyCommentHighlights(targetIdMap.mainArticle.prefix)"
          :highlight-mode="highlightMode"
          :text-count-mode="offer.description.isShowMaxLength"
          v-on="$listeners"
        />

        <section class="pt20 mlr10">
          <job-preview-section-title title="仕事内容" />
          <job-preview-description
            :description="offer.description"
            :comment-highlights="getAnyCommentHighlights(targetIdMap.description.prefix)"
            :highlight-mode="highlightMode"
            :text-count-mode="offer.description.isShowMaxLength"
            v-on="$listeners"
          />
        </section>

        <job-preview-entry-button
          :is-simple="offer.description.isSimple"
          :is-original-entry-form="offer.description.isOriginalEntryForm"
        />

        <section class="mlr10">
          <job-preview-section-title title="募集要項" />
          <job-preview-requirements
            :requirements="offer.requirements"
            :comment-highlights="getAnyCommentHighlights(targetIdMap.requirements.prefix)"
            :highlight-mode="highlightMode"
            :text-count-mode="offer.description.isShowMaxLength"
            v-on="$listeners"
          />

          <!-- JobPreviewFreeTopics（フリートピックス[n]_フリートピックスタイトル、トピックス内容、写真 -->
          <job-preview-free-topics
            v-for="(freeTopic, i) in getFreeTopics(offer, false)"
            :key="i"
            :free-topic="freeTopic"
            :comment-highlights="getAnyCommentHighlights(targetIdMap.freeTopics.prefix, freeTopic.index)"
            :highlight-mode="highlightMode"
            :text-count-mode="offer.description.isShowMaxLength"
            v-on="$listeners"
          />

          <!-- JobPreviewFeature（働く環境の特徴、この仕事の特徴）-->
          <job-preview-feature
            :requirements="offer.requirements"
            :comment-highlights="getAnyCommentHighlights(targetIdMap.feature.prefix)"
            :highlight-mode="highlightMode"
            :text-count-mode="offer.description.isShowMaxLength"
            v-on="$listeners"
          />

          <div class="clearfix" />

          <!-- JobPreviewViewPoints（女の転職！取材レポート）-->
          <job-preview-view-points
            v-if="!offer.description.isLightPlan && offer.requirements.report.body"
            :report="offer.requirements.report"
            :interviews="getFreeTopics(offer, true)"
            :comment-highlights="commentHighlightsViewPoint"
            :highlight-mode="highlightMode"
            :text-count-mode="offer.description.isShowMaxLength"
            v-on="$listeners"
          />

          <!-- JobPreviewRealIntention（社員からの評判・口コミ） -->
          <job-preview-real-intention
            v-if="offer.realIntentions.length"
            :company-name="offer.companyInfo.name"
            :real-intentions="offer.realIntentions"
            :comment-highlights="getAnyCommentHighlights(targetIdMap.realIntention.prefix)"
            :highlight-mode="highlightMode"
            :text-count-mode="offer.description.isShowMaxLength"
            v-on="$listeners"
          />
        </section>

        <job-preview-entry-button
          :is-simple="offer.description.isSimple"
          :is-original-entry-form="offer.description.isOriginalEntryForm"
        />

        <section class="mlr10">
          <job-preview-section-title title="会社概要" />
          <job-preview-company-info
            :is-light-plan="offer.description.isLightPlan"
            :company-info="offer.companyInfo"
            :comment-highlights="getAnyCommentHighlights(targetIdMap.companyInfo.prefix)"
            :highlight-mode="highlightMode"
            :text-count-mode="offer.description.isShowMaxLength"
            v-on="$listeners"
          />
        </section>

        <section class="pt20 mlr10">
          <job-preview-section-title title="応募・選考" />
          <job-preview-selection
            :company-name="offer.companyInfo.name"
            :selection="offer.selection"
            :comment-highlights="getAnyCommentHighlights(targetIdMap.selection.prefix)"
            :highlight-mode="highlightMode"
            :text-count-mode="offer.description.isShowMaxLength"
            v-on="$listeners"
          />

          <!-- JobPreviewDataForJob（データで見る働く環境（求人版）_女性社員の割合、残業時間（平均）、有給取得率）-->
          <job-preview-data-for-job
            v-if="isShowEnvironment(offer.environment)"
            :company-name="offer.companyInfo.name"
            :environment="offer.environment"
            :comment-highlights="getAnyCommentHighlights(targetIdMap.environment.prefix,targetIdMap.environment.job.suffix)"
            :highlight-mode="highlightMode"
            v-on="$listeners"
          />
        </section>

        <job-preview-entry-button
          :is-simple="offer.description.isSimple"
          :is-original-entry-form="offer.description.isOriginalEntryForm"
        />
      </div>
    </div>
    <div
      v-if="isShowEnvironment(offer.environment)"
      class="inner margin-0"
      data-test="environmentForCompany"
    >
      <p>
        <span class="hide-msg">「データをすべて見る」を押下すると、以下の内容が表示されます。</span>
      </p>
      <div class="inner">
        <div class="plr30 company-preview">
          <section class="mt20 mb20">
            <!-- JobPreviewDataForCompany （データで見る働く環境（企業情報版））-->
            <job-preview-data-for-company
              :environment="offer.environment"
              :comment-highlights="getAnyCommentHighlights(targetIdMap.environment.prefix,targetIdMap.environment.company.suffix)"
              :highlight-mode="highlightMode"
              v-on="$listeners"
            />
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/offer/base" as *;
</style>

<script>
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import JobPreviewHeader from '@/components/molecules/JobPreviewHeader'
import JobPreviewMainArticle from '@/components/molecules/JobPreviewMainArticle'
import JobPreviewSectionTitle from '@/components/atoms/JobPreviewSectionTitle'
import JobPreviewDescription from '@/components/organisms/JobPreviewDescription'
import JobPreviewEntryButton from '@/components/atoms/JobPreviewEntryButton'
import JobPreviewRequirements from '@/components/organisms/JobPreviewRequirements'
import JobPreviewFreeTopics from '@/components/molecules/JobPreviewFreeTopics'
import JobPreviewFeature from '@/components/molecules/JobPreviewFeature'
import JobPreviewViewPoints from '@/components/molecules/JobPreviewViewPoints'
import JobPreviewRealIntention from '@/components/molecules/JobPreviewRealIntention'
import JobPreviewCompanyInfo from '@/components/organisms/JobPreviewCompanyInfo'
import JobPreviewSelection from '@/components/organisms/JobPreviewSelection'
import JobPreviewDataForJob from '@/components/molecules/JobPreviewDataForJob'
import JobPreviewDataForCompany from '@/components/molecules/JobPreviewDataForCompany'

export default {
  components: {
    JobPreviewHeader,
    JobPreviewMainArticle,
    JobPreviewSectionTitle,
    JobPreviewDescription,
    JobPreviewEntryButton,
    JobPreviewRequirements,
    JobPreviewFreeTopics,
    JobPreviewFeature,
    JobPreviewViewPoints,
    JobPreviewRealIntention,
    JobPreviewCompanyInfo,
    JobPreviewSelection,
    JobPreviewDataForJob,
    JobPreviewDataForCompany
  },
  mixins: [jobPreviewCommon],
  props: {
    offer: {
      type: Object,
      required: true
    },
    // コメントハイライト一覧API
    commentHighlights: {
      type: Array,
      default: () => []
    },
    highlightMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    commentHighlightsViewPoint () {
      const commentHighlightsViewPoint = [...this.getAnyCommentHighlights(this.targetIdMap.report.prefix)]
      this.getFreeTopics(this.offer, true).forEach(interview => {
        commentHighlightsViewPoint.push(...this.getAnyCommentHighlights(this.targetIdMap.freeTopics.prefix, interview.index))
      })
      return commentHighlightsViewPoint
    }
  }
}
</script>
